import React from 'react';

class SortingOption extends React.Component {
  constructor(props) {
    super(props);
    this.handleSortingAttribute = this.handleSortingAttribute.bind(this);
    this.handleSortBy = this.handleSortBy.bind(this);
    this.state = {
      sortingAttr: '',
      sortBy: 'asc',
    };
  }
  handleSortingAttribute(event) {
    if (event.target.value !== '') {
      this.props.handleSortingAttribute(event.target.value);
    }
    this.setState({ sortingAttr: event.target.value });
  }
  handleSortBy(type, event) {
    event.preventDefault();
    this.props.handleSortBy(type);
    this.setState({ sortBy: type });
  }
  render() {
    const { sortingData } = this.props;
    const showSorting = (data, index) => {
      return (<option value={data.value} key={'sorting-' + index}>
        {data.title}
      </option>);
    };

    return (<div className="right-block">
      <div>Sort by:<select className="rq-selectbox" onChange={this.handleSortingAttribute} >
        <option value="">Default</option>
        {sortingData.map(showSorting)}
      </select>
      </div>
      { this.state.sortingAttr !== '' && <div>
        { this.state.sortBy === 'desc' && <button className="sorting-button" type="button" onClick={this.handleSortBy.bind(this, 'asc')}><i className="fa fa-chevron-down" aria-hidden="true"></i></button> }
        { this.state.sortBy === 'asc' && <button className="sorting-button" type="button" onClick={this.handleSortBy.bind(this, 'desc')}><i className="fa fa-chevron-up" aria-hidden="true"></i></button> }
      </div> }
    </div>);
  }
}


SortingOption.propTypes = {
  'sortingData': React.PropTypes.array,
  'handleSortBy': React.PropTypes.func,
  'handleSortingAttribute': React.PropTypes.func,
};

export default SortingOption;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/bar/sortingOption.js
 **/